/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Personalityarchetypelabelrebel3Inputs */



/**
* | output |
* | --- |
* | "The Wildcard" |
*
* @param {Personalityarchetypelabelrebel3Inputs} inputs
* @param {{ locale?: "ru" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const personalityarchetypelabelrebel3 = /** @type {((inputs?: Personalityarchetypelabelrebel3Inputs, options?: { locale?: "ru" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Personalityarchetypelabelrebel3Inputs, { locale?: "ru" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("The Wildcard")
	if (locale === "es") return /** @type {LocalizedString} */ ("El Comodín")
	return /** @type {LocalizedString} */ ("Дикарь")
});
export { personalityarchetypelabelrebel3 as "personalityArchetypeLabelRebel" }